import * as models from 'smg/customer-api/models';
import * as html from 'smg/html';
import * as smgphone from 'smg/phone';
import * as template from 'smg/template';

export function Draw(addressInit: models.IAddress, el: HTMLElement = template.Clone('#address-template').firstElementChild as HTMLElement): HTMLElement {
    const address = new models.Address(addressInit);
    const lines = el.querySelector('.address-lines');
    if (lines) {
        // Phone/email render in dedicated slots below — don't also embed them in the block.
        lines.innerHTML = html.Nl2br(address.toStringWithoutContact());
    }

    const phone = address.phoneNumber?.phone;
    const phoneEl = el.querySelector<HTMLAnchorElement>('.address-phone');
    if (phone) {
        if (phoneEl) {
            phoneEl.textContent = smgphone.Human(phone);
            phoneEl.href = smgphone.Format(phone);
        }
    } else {
        phoneEl?.closest('.address-phone-parent')?.remove();
        phoneEl?.remove();
    }

    const email = address.emailAddress?.email;
    const emailEl = el.querySelector<HTMLAnchorElement>('.address-email');
    if (email) {
        if (emailEl) {
            emailEl.textContent = email;
            emailEl.href = `mailto:${email}`;
        }
    } else {
        emailEl?.closest('.address-email-parent')?.remove();
        emailEl?.remove();
    }

    return el;
}
